import LocalizedFileInput from 'components/Erp/LocalizedFileInput';
import VehicleNumberInput from 'components/Forms/VehicleNumberInput/VehicleNumberInput.tsx';
import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { X, Plus } from 'lucide-react';
import React from 'react'
import styles from '../AdminPanelPage.module.scss'

// Форма создания водителя для ТЭЦ — аналог CreateDriverForm (top_base -> chpp)
const CreateChppDriverForm = ({ employees = [], employeeSearch = '', setEmployeeSearch = () => {}, modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createDriver, loadDriversByChpp = async () => {}, notifySuccess = () => {}, notifyError = () => {}, uploadDriverDocuments }) => {
  useInterfaceLanguage();
  const [selectedFiles, setSelectedFiles] = React.useState([])
  const fileInputRef = React.useRef(null)
  
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || [])
    setSelectedFiles(prevFiles => [...prevFiles, ...files])
    if (fileInputRef.current) fileInputRef.current.value = ''
  }
  
  const removeFile = (index) => {
    setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index))
  }
  
  const handleCreate = async () => {
    try {
      const payload = { ...modalPayload }
      if (modalPayload.chpp_name) delete payload.chpp_name
      
      const response = await createDriver(payload)
      const driverId = response?.data?.id
      
      if (selectedFiles.length > 0 && driverId) {
        try {
          await uploadDriverDocuments(driverId, selectedFiles)
        } catch (docErr) {
          console.error('Failed to upload documents:', docErr)
          notifyError(docErr, tr("Водитель создан, но не удалось загрузить документы"))
        }
      }
      
      if (payload.chpp) await loadDriversByChpp(payload.chpp)
      closeModal()
      notifySuccess(tr("Водитель создан"))
    } catch (err) {
      console.error(err)
      notifyError(err, tr("Не удалось создать водителя"))
    }
  }
  
  return (
    <>
      <label>{tr("Сотрудник")}</label>
      <input
        placeholder={tr("Поиск сотрудника...")}
        value={employeeSearch}
        onChange={(e) => setEmployeeSearch(e.target.value)}
      />
      <select value={modalPayload.employee || ''} onChange={(e) => setModalPayload(p => ({ ...p, employee: Number(e.target.value) }))}>
        <option value="">{tr("— Выберите сотрудника —")}</option>
        {employees.filter(emp => (emp.label || '').toLowerCase().includes(employeeSearch.toLowerCase())).map(emp => (
          <option key={emp.id} value={emp.id}>{tr(emp.label)}</option>
        ))}
      </select>

      <label>{tr("ТЭЦ")}</label>
      <input placeholder={tr("ТЭЦ")} value={modalPayload.chpp_name || modalPayload.chpp || ''} readOnly />

      <label>{tr("Номер автомобиля")}</label>
      <VehicleNumberInput value={modalPayload.vehicle_number || ''} onChange={(e) => setModalPayload(p => ({ ...p, vehicle_number: e.target.value }))} />

      <label>{tr("Модель автомобиля")}</label>
      <input placeholder={tr("Модель машины")} value={modalPayload.vehicle_model || ''} onChange={(e) => setModalPayload(p => ({ ...p, vehicle_model: e.target.value }))} />
      
      <label>{tr("Документы")}</label>
      <LocalizedFileInput 
        ref={fileInputRef}
        type="file" 
        multiple 
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
        onChange={handleFileChange}
      />
      {tr(selectedFiles.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <strong>{tr("Выбранные файлы:")}</strong>
          <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
            {selectedFiles.map((file, index) => (
              <li key={index}>
                {tr(file.name)} ({(file.size / 1024).toFixed(1)}{tr(" КБ)")}<button 
                  type="button"
                  onClick={() => removeFile(index)}
                  style={{ marginLeft: 8, color: "var(--theme-danger-text, red)", cursor: 'pointer', background: 'none', border: 'none' }}
                 aria-label={tr("Удалить выбранный файл")}><X size={14} aria-hidden="true"/></button>
              </li>
            ))}
          </ul>
        </div>
      ))}
      
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
        <button onClick={handleCreate} className={styles.btn_pin}><Plus size={14} aria-hidden="true"/>{tr(" Создать")}</button>
      </div>
    </>
  )
}

export default CreateChppDriverForm
